import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { downloadBlob } from '@/_shared/helpers/download';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_TRAINING_EXPORT_PATH_KEY } from '@/swagger/constants/reports-keys';
import { API_GET_REPORT_TRAINING_EXPORT, KEY_GET_REPORT_TRAINING_EXPORT } from '../constants';
import { MOCK_RESPONSE_GET_REPORT_TRAINING_EXPORT } from '../mocks';
import { CallResponseGetReportTrainingExport } from '../types';

type RequestGetReportTrainingExportPath = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_TRAINING_EXPORT_PATH_KEY
>['request']['path'];

export type CallParamsGetReportTrainingExport = Omit<
  RequestGetReportTrainingExportPath,
  'organizationId'
> & {
  fileName?: string;
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallErrorGetReportTrainingExport = GenericApiError;

type CallSelectorsGetReportTrainingExport = unknown;

let fileName: string | undefined;

export const getReportTrainingExportCall = createGeneralCall<
  CallParamsGetReportTrainingExport,
  CallResponseGetReportTrainingExport,
  CallErrorGetReportTrainingExport,
  CallSelectorsGetReportTrainingExport
>({
  id: KEY_GET_REPORT_TRAINING_EXPORT,
  url:
    ({ payload: { fileName: givenFileName = 'reporting-training' } }) =>
    state => {
      fileName = givenFileName || undefined;
      const org = getCurrentOrganization(state);
      return API_GET_REPORT_TRAINING_EXPORT(org as unknown as string);
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_REPORT_TRAINING_EXPORT : undefined,
  responseExtractor: 'blob',
  responseMapper: ({ response: blob }) => {
    downloadBlob(blob, fileName);
  },
});
